import React from 'react';
import { useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';

function Privacy({ loggedIn, username }) {
  const { t } = useTranslation();
  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('privacyPage.title')}</h1>
          <div className={styles.content}>
            <p><em>{t('privacyPage.lastUpdated')}</em></p>

            <h2>{t('privacyPage.s1Title')}</h2>
            <p>{t('privacyPage.s1Text')}</p>

            <h2>{t('privacyPage.s2Title')}</h2>
            <p>{t('privacyPage.s2Intro')}</p>
            <ul>
              <li><strong>{t('privacyPage.s2IdentityLabel')}</strong> {t('privacyPage.s2IdentityText')}</li>
              <li><strong>{t('privacyPage.s2ProfileLabel')}</strong> {t('privacyPage.s2ProfileText')}</li>
              <li><strong>{t('privacyPage.s2UsageLabel')}</strong> {t('privacyPage.s2UsageText')}</li>
            </ul>

            <h2>{t('privacyPage.s3Title')}</h2>
            <p>{t('privacyPage.s3Intro')}</p>
            <ul>
              <li>{t('privacyPage.s3Item1')}</li>
              <li>{t('privacyPage.s3Item2')}</li>
              <li>{t('privacyPage.s3Item3')}</li>
              <li>{t('privacyPage.s3Item4')}</li>
            </ul>

            <h2>{t('privacyPage.s4Title')}</h2>
            <p>{t('privacyPage.s4Text')}</p>

            <h2>{t('privacyPage.s5Title')}</h2>
            <p>{t('privacyPage.s5Intro')}</p>
            <ul>
              <li>{t('privacyPage.s5Item1')}</li>
              <li>{t('privacyPage.s5Item2')}</li>
              <li>{t('privacyPage.s5Item3')}</li>
              <li>{t('privacyPage.s5Item4')}</li>
              <li>{t('privacyPage.s5Item5')}</li>
            </ul>

            <h2>{t('privacyPage.s6Title')}</h2>
            <p>{t('privacyPage.s6Text')}</p>

            <h2>{t('privacyPage.s7Title')}</h2>
            <p>{t('privacyPage.s7Text')}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Privacy;
